
export const CATEGORY_SUBCATEGORY_ORDER = {
    EN: {
        "LG Studio": [
            "Refrigeration",
            "Built-in Cooking",
            "Free-standing Cooking",
            "Ventilation",
            "Dishwashers",
            "Laundry",
        ],
        "Laundry": [
            "Front Load",
            "WashTower",
            "Top Load",
            "Specialty Laundry",
            "Accessories" // NEW
            // "Styler",

        ],
        "Refrigeration": [
            "36\" French Door Standard Depth",
            "36\" French Door Counter Depth",
            "33\" French Door Standard Depth",
            "33\" French Door Counter Depth",
            "30\" French Door",
            "Top and Bottom Mount",
            "Side-by-Side",
            "Column",
            "Kimchi",

        ],
        "Cooking": [
            "Electric Slide-in Ranges",
            "Electric Free-standing Ranges",
            "Induction Ranges",
            "Gas Ranges",
            "Wall Ovens",
            "Cooktops",
            "Over-the-Range Microwaves",
            "Countertop Microwaves",
        ],
        "Dishwasher": [
            "Built-in"
        ],
    },

    FR: {
        "LG Studio": [
            "Réfrigérateur",
            "Cuisson intégré",
            "Cuisson autonome",
            "Ventilation",
            "Lave-vaisselles",
            "Lessive",
        ],
        "Lessive": [
            "Chargement frontal",
            "WashTower",
            "Chargement vertical",
            "Appareils spécialisés",
            // "Styler"
        ],
        "Réfrigérateur": [
            "Porte à deux battants profondeur standard de 36 po",
            "Porte à deux battants profondeur de comptoir de 36 po",
            "Porte à deux battants profondeur standard de 33 po",
            "Porte à deux battants profondeur de comptoir de 33 po",
            "Porte à deux battants de 30 po",
            "Congélateur en haut et bas",
            "Côte-à-côte",
            "Colonne",
            "Kimchi"
        ],
        "Cuisson": [
            "Cuisinière encastrable électrique",
            "Cuisinières encastrable électriques",
            "Cuisinières à inductions",
            "Cuisinière au gaz",
            "Four mural",
            "Surface de cuisson",
            "Four à micro-ondes à hotte intégrée",
            "Four à micro-ondes de comptoir",
        ],
        "Lave-vaisselle": [
            "Intégré"
        ],
    }

}


export const SUBCATEGORY_NAMING_MAP = {

    "refrigeration": "Refrigeration",
    "built-in cooking": "Built-in Cooking",
    "free-standing cooking": "Free-standing Cooking",
    "ventilation": "Ventilation",
    "dishwashers": "Dishwashers",
    "laundry": "Laundry",
    "front load": "Front Load",
    "washtower": "WashTower",
    "top load": "Top Load",
    "specialty laundry": "Specialty Laundry",
    "accessories": "Accessories",
    "36\" french door standard depth": "36\" French Door Standard Depth",
    "36\" french door counter depth": "36\" French Door Counter Depth",
    "33\" french door standard depth": "33\" French Door Standard Depth",
    "33\" french door counter depth": "33\" French Door Counter Depth",
    "30\" french door": "30\" French Door",
    "top and bottom mount": "Top and Bottom Mount",
    "side-by-side": "Side-by-Side",
    "column": "Column",
    "kimchi": "Kimchi",
    "electric slide-in ranges": "Electric Slide-in Ranges",
    "electric free-standing ranges": "Electric Free-standing Ranges",
    "induction ranges": "Induction Ranges",
    "gas ranges": "Gas Ranges",
    "wall ovens": "Wall Ovens",
    "cooktops": "Cooktops",
    "over-the-range microwaves": "Over-the-Range Microwaves",
    "countertop microwaves": "Countertop Microwaves",
    "built-in": "Built-in",

    // FRENCH - IF BUGGY - SPLIT THIS INTO NEW OBJECT AND USE LANG TO DETERMINE WHICH TO USE
    "réfrigérateur": "Réfrigérateur",
    "cuisson intégré": "Cuisson intégré",
    "cuisson autonome": "Cuisson autonome",
    "ventilation": "Ventilation",
    "lave-vaisselles": "Lave-vaisselles",
    "lessive": "Lessive",
    "chargement frontal": "Chargement frontal",
    "washtower": "WashTower",
    "chargement vertical": "Chargement vertical",
    "appareils spécialisés": "Appareils spécialisés",
    "porte à deux battants profondeur standard de 36 po": "Porte à deux battants profondeur standard de 36 po",
    "porte à deux battants profondeur de comptoir de 36 po": "Porte à deux battants profondeur de comptoir de 36 po",
    "porte à deux battants profondeur standard de 33 po": "Porte à deux battants profondeur standard de 33 po",
    "porte à deux battants profondeur de comptoir de 33 po": "Porte à deux battants profondeur de comptoir de 33 po",
    "porte à deux battants de 30 po": "Porte à deux battants de 30 po",
    "congélateur en haut et bas": "Congélateur en haut et bas",
    "côte-à-côte": "Côte-à-côte",
    "colonne": "Colonne",
    "kimchi": "Kimchi",
    "cuisinière encastrable électrique": "Cuisinière encastrable électrique",
    "cuisinières encastrable électriques": "Cuisinières encastrable électriques",
    "cuisinières à inductions": "Cuisinières à inductions",
    "cuisinière au gaz": "Cuisinière au gaz",
    "four mural": "Four mural",
    "surface de cuisson": "Surface de cuisson",
    "four à micro-ondes à hotte intégrée": "Four à micro-ondes à hotte intégrée",
    "four à micro-ondes de comptoir": "Four à micro-ondes de comptoir",
    "intégré": "Intégré"

}


// ==================================================================
// MAP PRODUCTS BY CAT: Used in
// - product context
// ==================================================================

export const mapProductsByCategory = (products) => {
    const categories = {};
    products.forEach(product => {
        // Always use the ENGLISH key for mapping!
        const key = product.categoryEN || product.category;
        if (!categories[key]) categories[key] = [];
        categories[key].push(product);
    });
    return categories;
};




// export const ListProductsByCategorySubcategory = (products) => {
//     return products.reduce((acc, product) => {
//         if (!acc[product.category]) {
//             acc[product.category] = {};
//         }
//         if (!acc[product.category][product.subcategory]) {
//             acc[product.category][product.subcategory] = [];
//         }
//         acc[product.category][product.subcategory].push(product);
//         return acc;
//     }, {});
// };
export const ListProductsByCategorySubcategory = (products, language = "EN") => {
    const subcatKey = language === "FR" ? "subcategoryFR" : "subcategoryEN";
    return products.reduce((acc, product) => {
        const subcatValue = product[subcatKey];
        if (!acc[subcatValue]) acc[subcatValue] = [];
        acc[subcatValue].push(product);
        return acc;
    }, {});
};


export const NormalizeCategoryId = (categoryId) => {
    const adjustments = {
        'air-care': 'air care',
    };
    return adjustments[categoryId] || categoryId;
};


export const FilterProductsByCategoryId = (products, categoryId) => {
    if (Array.isArray(products)) {
         return products.filter(product => product.categoryEN === categoryId);
        // return products.filter(product => product.category === categoryId);
    } else {
        console.error('FilterProductsByCategoryId: products is not an array', products);
        return [];
    }
}

export const sortProductsByMsrpAndTitle = (products) => {
  
  // Check if the input is an object (subcategory: [products...])
  if (typeof products === 'object' && products !== null) {
    // console.log("---- SORTING: Received products object ----");
    Object.entries(products).forEach(([category, prodArray]) => {
      // console.log(`\n> Category: "${category}" - Original order:`);
      prodArray.forEach((p, idx) => {
        // console.log(`  [${idx}] Title: "${p.title}" MSRP: ${p.msrp}`);
      });

      if (Array.isArray(prodArray)) {
        prodArray.sort((a, b) => {
          // Defensive: show both products being compared
          // console.log(
          //   `    Comparing "${a.title}" (MSRP: ${a.msrp}) and "${b.title}" (MSRP: ${b.msrp})`
          // );

          const msrpA = a.msrp !== null && a.msrp !== '' && !isNaN(a.msrp) ? parseFloat(a.msrp) : null;
          const msrpB = b.msrp !== null && b.msrp !== '' && !isNaN(b.msrp) ? parseFloat(b.msrp) : null;

          if (msrpA !== null && msrpB !== null) {
            const result = msrpB - msrpA;
            // console.log(`      Both have MSRP: ${msrpA} vs ${msrpB} => result: ${result}`);
            return result;
          }
          if (msrpA !== null) {
            // console.log(`      Only "${a.title}" has MSRP, so it comes first`);
            return -1;
          }
          if (msrpB !== null) {
            // console.log(`      Only "${b.title}" has MSRP, so it comes first`);
            return 1;
          }

          // Both missing MSRP; sort alphabetically
          const titleA = a.title ? a.title.replace(/[^a-zA-Z]/g, '').toLowerCase() : '';
          const titleB = b.title ? b.title.replace(/[^a-zA-Z]/g, '').toLowerCase() : '';
          const alpha = titleA.localeCompare(titleB);
          // console.log(`      Neither has MSRP. Compare titles: "${titleA}" vs "${titleB}" => ${alpha}`);
          return alpha;
        });

        // Log after sort
        // console.log(`> Category: "${category}" - Sorted order:`);
        prodArray.forEach((p, idx) => {
          // console.log(`  [${idx}] Title: "${p.title}" MSRP: ${p.msrp}`);
        });
      }
    });
    return products;
  } else {
    // console.log('sortProductsByMsrpAndTitle: Input is not an object or is invalid:', products);
    return products;
  }
};
